import { GRAPH_CHECK_COLUMN, TAB, ColorManager } from "../../pages/dataMonitor/dataMonitorUtil";

// グラフと横並び時のリストのシステム列の幅
const WITH_GRAPH_SYSTEM_ROW_WIDTH = 60;
// デフォルト文字色
const DEFAULT_STR_COLOR = ColorManager.DEFAULT_COLOR;

export default {
  name: 'dataMonitorMeasureListItem',
  data() {
    return {
      splitCheckValue: this.source.splitCheck,
      unionCheckValue: this.source.unionCheck,
      parentComponentName: 'dataMonitorMeasureList',
      scrollOffset: 0,
      tooltipLeftDelta: 0,
    };
  },
  props: {
    index: {
      type: Number
    },

    source: {
      type: Object,
      default() {
        return {};
      }
    },

    highlightItems: {
      type: Array
    },

    splitGraphLines: {
      type: Number
    },

    unionGraphLines: {
      type: Number
    },

    splitGraphMaxLines: {
      type: Number
    },

    unionGraphMaxLines: {
      type: Number
    },

    isSystemRow: {
      type: Boolean
    },

    currentTab: {
      type: Number
    },

    splitGraphItemColors: {
      type: Object, default: {}, required: false
    },

    unionGraphItemColors: {
      type: Object, default: {}, required: false
    },

    // マウスオーバー時に動的にスクロールの量を取得するため、refを受け取りコンポーネント内でスクロール量を算出
    listRef: {
      type: Object, default: {}, required: false
    },

    selectedRow: {
      type: Number
    },

    onClickRowCallback: {
      type: Function
    }
  },

  watch: {
    'source.splitCheck': {
      handler(value) {
        this.splitCheckValue = value;
      }
    },

    'source.unionCheck': {
      handler(value) {
        this.unionCheckValue = value;
      }
    }
  },

  /**
   * コンポーネント初期レンダリング時のライフサイクル関数
   */
  mounted() {
    // HTMLで使用するため、コンポーネントのインスタンス変数に設定
    this.GRAPH_CHECK_COLUMN = GRAPH_CHECK_COLUMN;
  },

  methods: {
    /**
     * 行CSS設定
     * @param {*} index 
     * @returns CSS設定
     */
    getRowStyle(index) {
      const tableStyles = ['data-monitor-virtual-row'];
      let idx = index;
      if (!idx) {
        idx = 0;
      }

      // 強調表示項目の場合、強調表示させる
      if (this.highlightItems && this.highlightItems.includes(this.source.data_monitor_id)) {
        tableStyles.push('data-monitor-column-highlight');

      }
      if (this.currentTab === TAB.UNION && this.selectedRow === this.source.line) {
        // カーソル項目行
        tableStyles.push('data-monitor-cursor-selected-row');
      } else {
        // 通常行
        tableStyles.push((idx % 2 === 0) ? 'data-monitor-border-row' : 'data-monitor-non-border-row');
      }

      return tableStyles;
    },

    /**
     * 行のスタイル設定。色が動的に変わりCSSでの定義ができないため、スタイルを直接設定
     * @returns {string} スタイル設定
     */
    getStyle() {
      if (this.currentTab === TAB.LIST) {
        // リストタブでは色の上書きを行わない
        return '';
      }

      if (this.currentTab === TAB.SPLIT && this.splitGraphItemColors[this.source.data_monitor_id]) {
        const color = this.splitGraphItemColors[this.source.data_monitor_id];
        return `color: ${color}`;
      }

      if (this.currentTab === TAB.UNION && this.unionGraphItemColors[this.source.data_monitor_id]) {
        const color = this.unionGraphItemColors[this.source.data_monitor_id];
        return `color: ${color}`;
      }

      return `color: ${DEFAULT_STR_COLOR}`;
    },

    /**
     * グラフ項目変更時処理
     * @param {*} col 分割G/結合G
     * @param {*} val チェック有無
     * @param {*} row 一覧のindex
     */
    handleChange(col, val, row) {
      let len = 0;
      let checkLen = 0;
      if (col === GRAPH_CHECK_COLUMN.SPLIT) {
        len = this.splitGraphLines;
        checkLen = this.splitGraphMaxLines;
      } else {
        len = this.unionGraphLines;
        checkLen = this.unionGraphMaxLines;
      }
      if (val) {
        len = len + 1;
      } else {
        len = len - 1;
      }
      // グラフ項目数を確認
      if (len > checkLen) {
        // ONをもとに戻す
        if (col === GRAPH_CHECK_COLUMN.SPLIT) {
          this.splitCheckValue = false;
        } else {
          this.unionCheckValue = false;
        }
        return;
      }
      this.dispatch(col, val, row);
    },

    /**
     * 親の処理呼び出し
     * @param {*} col 分割G/結合G
     * @param {*} val チェック有無
     * @param {*} row 一覧のindex
     */
    dispatch(col, val, row) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== this.parentComponentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.name;
        }
      }

      if (parent) {
        parent.changeCheckValue(col, val, row);
      }
    },

    handleMouseOver() {
      // 仮想リストがスクロールされた分だけ、ツールチップの位置を上げるため、負数で設定
      this.scrollOffset = this.listRef && this.listRef.getOffset ? -(this.listRef.getOffset()) : 0;
      // システム列がある場合、ツールチップの位置をその分だけずらす
      this.tooltipLeftDelta = this.isSystemRow ? WITH_GRAPH_SYSTEM_ROW_WIDTH : 0;
    },

    onClickRow(line) {
      this.onClickRowCallback(line, this.unionCheckValue);
    },
  },
};
